const Events = {
  LOGIN_USER: 'Login User',
  LOGOUT_USER: 'Logout User',
  MOVE_SCENES: 'Move Scenes',
  IA_RESUME: 'Resume with IA',
  END_DECOUPAGE: 'End Decoupage',
  REOPEN_SCRIPT: 'Reopen Script',
  EXTRACT_COVER: 'Extract Cover',
  EXTRACT_SCRIPT: 'Extract Script',
  PRODUCT_CHANGE: 'Product Change',
  RELEASE_SCRIPT: 'Release Script',
  START_DECOUPAGE: 'Start Decoupage',
  REMOVE_CHARACTERS: 'Remove Characters',
  FINISH_SCENE_EPROD: 'Finish Scene in Eprod',
  APPLY_RESUME_WITh_IA: 'Apply Resume with IA',
  RELEASE_SCENE_EPROD: 'Release Scene in Eprod',
  RECORDED_SCENE_EPROD: 'Recorded Scene in Eprod',
  CANCELED_SCENE_EPROD: 'Canceled Scene in Eprod',
  CONTINUED_SCENE_EPROD: 'Continued Scene in Eprod',
  GENERATE_MATERIALS_WITH_IA: 'Generate scene elements with AI',
  REGENERATE_MATERIALS_WITH_IA: 'Regenerate scene elements with AI',
};

const EventNames = {
  LOGIN_USER: 'login_user',
  LOGOUT_USER: 'logout_user',
  MOVE_SCENES: 'move_scenes',
  EXTRACT_COVER: 'extract_cover',
  REOPEN_SCRIPT: 'reopen_script',
  END_DECOUPAGE: 'end_decoupage',
  PRODUCT_CHANGE: 'product_change',
  RESUME_WITH_IA: 'resume_with_ia',
  RELEASE_SCRIPT: 'release_script',
  EXTRACT_SCRIPT: 'extract_script',
  START_DECOUPAGE: 'start_decoupage',
  REMOVE_CHARACTERS: 'remove_characters',
  FINISH_SCENE_EPROD: 'finish_scene_eprod',
  RELEASE_SCENE_EPROD: 'release_scene_eprod',
  RECORDED_SCENE_EPROD: 'recorded_scene_eprod',
  APPLY_RESUME_WITh_IA: 'apply_resume_with_ia',
  CANCELED_SCENE_EPROD: 'canceled_scene_eprod',
  CONTINUED_SCENE_EPROD: 'continued_scene_eprod',
  GENERATE_MATERIALS_WITH_IA: 'generate_materials_with_ia',
  REGENERATE_MATERIALS_WITH_IA: 'regenerate_materials_with_ia',
};

export { Events, EventNames };
